import React from 'react';
import './meetus3.css'
import Mainbt from '../components/common/mainbt';
import Meetusdiv from '../components/common/meetusdiv';
import m3 from '../assets/m3Icon.svg'

const Meetus3 = () => {
    return ( <>
    <section>
            <div className="container">
                <div className="meets3">
                <Meetusdiv 
                muicon={m3}
                dicovertext='Access Digital Tickets'
                mup='Your premium pass with QR codes, seat details, and instant venue access'
                />
                <Mainbt mainbt="Next" link="/meetus4" />
                </div>
            
            </div>
    </section>
    </> );
}
 
export default Meetus3 ;